import axios from "axios"
import Cookies from 'js-cookie';

const BaseURL = import.meta.env.VITE_BASEURL;

export const UpdateIOT_M_Sensor = async (params, data) => {
    const token = Cookies.get('auth_token');
    const response = await axios.put(
        `${BaseURL}/update/iot_m_sensor`, data, {
        params,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    );
    return response;
}